import {
  UI_MODE_SET,
  INFO_CONSOLE_TOGGLE,
  MOBILE_WELCOME_ACKNOWLEDGE,
  SCROLL_LOCK_SET,
  COMPONENT_FOCUS_SET,
  COMPONENT_FOCUS_RESET
} from './ActionTypes';

import {getCurrentInvite} from '../selectors';
import getReadStatusKeyName from '../utils/getReadStatusKeyName.js';

import history from '../history.js';

export const setUiMode = (props) => {
  return dispatch => {
    dispatch({
      type: UI_MODE_SET,
      payload: props
    });
  };
};

export const toggleInfoConsole = () => {
  return dispatch => {
    dispatch({
      type: INFO_CONSOLE_TOGGLE
    });
  };
};

export const acknowledgeMobileWelcome = () => {
  return (dispatch, getState) => {
    const invite = getCurrentInvite(getState());
    const keyName = getReadStatusKeyName(invite);

    localStorage.setItem(keyName, new Date().toISOString());

    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set('slideIndex', 0);
    history.replace(currentURL.pathname + currentURL.search);

    dispatch({
      type: MOBILE_WELCOME_ACKNOWLEDGE
    });
  };
};

export const setScrollLock = (shouldScrollLock) => (dispatch) => {
  return dispatch({
    type: SCROLL_LOCK_SET,
    payload: {
      shouldScrollLock
    }
  });
};

export const setComponentFocus = (id) => (dispatch) => {
  return dispatch({
    type: COMPONENT_FOCUS_SET,
    payload: {
      id
    }
  });
};
